var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DrawerBody, DrawerHeader, FormController, FormLabel, Input, Typography, } from '@one-thd/sui-atomic-components';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { AddInstoreReceipt } from '../../../../api/oms/order-history';
import { inStoreErrors } from '../../../../constants/receipt-error';
import { useCommonContext } from '../../../../hooks/useContexts';
import { addHyphens, addSlash, makeInStoreRequestBody, } from '../../../../utils/order-history';
import { AddReceiptDrawerFooter } from './AddReceiptDrawerFooter';
export var InStoreReceiptForm = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var closeDrawer = _a.closeDrawer, setAlertState = _a.setAlertState, svocId = _a.svocId;
    var _j = useState({
        receiptNumber: '',
        salesDate: '',
        preTaxAmount: '',
    }), inputError = _j[0], setInputError = _j[1];
    var _k = useState(false), isLoading = _k[0], setLoading = _k[1];
    var isMobile = useCommonContext().isMobile;
    var _l = useForm({
        mode: 'onBlur',
        defaultValues: {
            preTaxAmount: '',
            receiptNumber: '',
            salesDate: '',
            tryAgain404: false,
            apiError: false,
        },
    }), clearErrors = _l.clearErrors, errors = _l.formState.errors, handleSubmit = _l.handleSubmit, register = _l.register, reset = _l.reset, setError = _l.setError, setValue = _l.setValue, watch = _l.watch;
    var watchReceiptNumber = watch('receiptNumber');
    var watchSalesDate = watch('salesDate');
    var watchPreTaxAmount = watch('preTaxAmount');
    useEffect(function () {
        var invalidChars = /[$&+,:;=\\?@(){}~%\][|/'<>.^*()%!]/;
        if (invalidChars === null || invalidChars === void 0 ? void 0 : invalidChars.test(watchReceiptNumber)) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { receiptNumber: 'error' })); });
            setError('receiptNumber', { type: 'invalid', message: 'invalid entry' });
            return;
        }
        if ((watchReceiptNumber === null || watchReceiptNumber === void 0 ? void 0 : watchReceiptNumber.length) === 16) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { receiptNumber: 'success' })); });
            clearErrors('receiptNumber');
        }
        if ((inputError === null || inputError === void 0 ? void 0 : inputError.receiptNumber) === 'success' &&
            (watchReceiptNumber === null || watchReceiptNumber === void 0 ? void 0 : watchReceiptNumber.length) !== 16) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { receiptNumber: 'error' })); });
            setError('receiptNumber', { type: 'invalid', message: 'invalid entry' });
        }
    }, [watchReceiptNumber]);
    useEffect(function () {
        if ((watchSalesDate === null || watchSalesDate === void 0 ? void 0 : watchSalesDate.length) === 8) {
            var tempYear = watchSalesDate === null || watchSalesDate === void 0 ? void 0 : watchSalesDate.split('/');
            var tempDate = new Date("".concat(tempYear[2] < '20' ? '19' : '20').concat(tempYear[2], "/").concat(tempYear[0], "/").concat(tempYear[1]));
            if (Number.isNaN(tempDate.getTime())) {
                setInputError(function (prevState) { return (__assign(__assign({}, prevState), { salesDate: 'error' })); });
                setError('salesDate', { type: 'invalid', message: 'invalid entry' });
                return;
            }
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { salesDate: 'success' })); });
            clearErrors('salesDate');
            return;
        }
        if ((inputError === null || inputError === void 0 ? void 0 : inputError.salesDate) === 'success' && (watchSalesDate === null || watchSalesDate === void 0 ? void 0 : watchSalesDate.length) !== 8) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { salesDate: 'error' })); });
            setError('salesDate', { type: 'invalid', message: 'invalid entry' });
        }
    }, [watchSalesDate]);
    useEffect(function () {
        if ((watchPreTaxAmount === null || watchPreTaxAmount === void 0 ? void 0 : watchPreTaxAmount.length) > 3 && (watchPreTaxAmount === null || watchPreTaxAmount === void 0 ? void 0 : watchPreTaxAmount.at(-3)) === '.') {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { preTaxAmount: 'success' })); });
            clearErrors('preTaxAmount');
        }
        else if ((watchPreTaxAmount === null || watchPreTaxAmount === void 0 ? void 0 : watchPreTaxAmount.length) > 1 &&
            (watchPreTaxAmount === null || watchPreTaxAmount === void 0 ? void 0 : watchPreTaxAmount.at(-3)) !== '.') {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { preTaxAmount: 'error' })); });
        }
        if ((inputError === null || inputError === void 0 ? void 0 : inputError.preTaxAmount) === 'success' &&
            ((watchPreTaxAmount === null || watchPreTaxAmount === void 0 ? void 0 : watchPreTaxAmount.length) < 3 || (watchPreTaxAmount === null || watchPreTaxAmount === void 0 ? void 0 : watchPreTaxAmount.at(-3)) !== '.')) {
            setInputError(function (prevState) { return (__assign(__assign({}, prevState), { preTaxAmount: 'error' })); });
            setError('preTaxAmount', { type: 'invalid', message: 'invalid entry' });
        }
    }, [watchPreTaxAmount]);
    var onFormSubmit = function (_a) {
        var preTaxAmount = _a.preTaxAmount, receiptNumber = _a.receiptNumber, salesDate = _a.salesDate;
        return __awaiter(void 0, void 0, void 0, function () {
            var request, response, status_1, error_1, errorDescription, errorMessage;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0:
                        clearErrors();
                        _m.label = 1;
                    case 1:
                        _m.trys.push([1, 4, 5, 6]);
                        request = void 0;
                        if (!(preTaxAmount && receiptNumber && salesDate && svocId)) return [3 /*break*/, 3];
                        setLoading(true);
                        request = makeInStoreRequestBody(svocId, receiptNumber, salesDate, preTaxAmount);
                        return [4 /*yield*/, AddInstoreReceipt(request)];
                    case 2:
                        response = _m.sent();
                        status_1 = response ? response.status : null;
                        if (status_1 === null) {
                            setError('tryAgain404', {
                                type: 'failed',
                                message: 'failed request',
                            });
                            return [2 /*return*/];
                        }
                        closeDrawer();
                        reset();
                        setAlertState({
                            alertMessage: "You've successfully added an in-store receipt to your account. View Receipt ".concat(receiptNumber),
                            status: 'success',
                        });
                        _m.label = 3;
                    case 3: return [3 /*break*/, 6];
                    case 4:
                        error_1 = _m.sent();
                        errorDescription = (_e = (_d = (_c = (_b = error_1.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.error) === null || _d === void 0 ? void 0 : _d[0]) === null || _e === void 0 ? void 0 : _e.description;
                        if (error_1.response.status === 500) {
                            setError('tryAgain404', {
                                type: 'failed',
                                message: 'failed request',
                            });
                            return [2 /*return*/];
                        }
                        errorMessage = void 0;
                        try {
                            errorMessage = (_l = (_k = (_j = (_h = (_g = (_f = JSON.parse(errorDescription)) === null || _f === void 0 ? void 0 : _f.addReceiptResponse) === null || _g === void 0 ? void 0 : _g.receipts) === null || _h === void 0 ? void 0 : _h[0]) === null || _j === void 0 ? void 0 : _j.errors) === null || _k === void 0 ? void 0 : _k[0]) === null || _l === void 0 ? void 0 : _l.description;
                        }
                        catch (err) {
                            errorMessage =
                                'We were unable to retrieve your receipt details. Refresh the page and try again.';
                        }
                        setError('apiError', {
                            type: 'failed',
                            message: errorMessage,
                        });
                        return [3 /*break*/, 6];
                    case 5:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    var handleButtonClick = function () {
        clearErrors();
        handleSubmit(onFormSubmit)();
    };
    return (React.createElement("div", { "data-testid": "instoreReceiptForm", className: "sui-flex sui-flex-col sui-h-full" },
        React.createElement(DrawerHeader, { title: "Add In-Store Receipt", onClose: closeDrawer }),
        React.createElement(DrawerBody, { style: { height: isMobile ? '65vh' : '' } },
            React.createElement(Typography, { variant: "body-base" }, "Please enter the following details found on your receipt:"),
            React.createElement("div", { className: "sui-mt-2 sui-flex sui-justify-center" },
                React.createElement("img", { src: "https://assets.thdstatic.com/images/v1/ReceiptImage.svg", alt: "Receipt Example", width: isMobile ? '280px' : '320px', height: isMobile ? '180px' : '210px' })),
            React.createElement(FormController, { className: "sui-mt-[8px] md:sui-mt-6", fullWidth: true, status: inputError.receiptNumber || ((errors === null || errors === void 0 ? void 0 : errors.receiptNumber) && 'error') },
                React.createElement(FormLabel, { htmlFor: "receiptNumber" },
                    "Receipt Number",
                    React.createElement("sup", null, "*")),
                React.createElement(Input, __assign({ "aria-describedby": "receiptNumber-input", fullWidth: true, id: "receiptNumber", inputProps: {
                        maxLength: 16,
                    } }, register('receiptNumber', {
                    required: true,
                    minLength: 15,
                    onChange: function (event) {
                        return setValue('receiptNumber', addHyphens(event.target.value.toUpperCase()));
                    },
                    onBlur: function (event) {
                        return setValue('receiptNumber', addHyphens(event.target.value.toUpperCase()));
                    },
                }), { placeholder: "XXXX-XXXXX-XXXXX" })),
                (inputError.receiptNumber === 'error' || errors.receiptNumber) && (React.createElement(Typography, { variant: "body-xs", color: "danger" },
                    ((_b = errors === null || errors === void 0 ? void 0 : errors.receiptNumber) === null || _b === void 0 ? void 0 : _b.type) === 'tryAgain' &&
                        inStoreErrors.receiptNumberNotFound,
                    (['required', 'minLength', 'invalid', 'pattern'].includes((_d = (_c = errors === null || errors === void 0 ? void 0 : errors.receiptNumber) === null || _c === void 0 ? void 0 : _c.type) !== null && _d !== void 0 ? _d : 'invalid') ||
                        inputError.receiptNumber === 'error') &&
                        inStoreErrors.receiptNumberInvalidFormat))),
            React.createElement(FormController, { className: "sui-mt-[8px] md:sui-mt-6", fullWidth: true, status: inputError.salesDate || ((errors === null || errors === void 0 ? void 0 : errors.salesDate) && 'error') },
                React.createElement(FormLabel, { htmlFor: "salesDate" },
                    "Purchase Date",
                    React.createElement("sup", null, "*")),
                React.createElement(Input, __assign({ "aria-describedby": "salesDate-input", fullWidth: true, id: "salesDate", inputProps: {
                        maxLength: 8,
                    } }, register('salesDate', {
                    required: true,
                    minLength: 7,
                    pattern: /^(\d{2})\/(\d{2})\/(\d{2})$/,
                    onChange: function (event) {
                        return setValue('salesDate', addSlash(event.target.value));
                    },
                    onBlur: function (event) {
                        return setValue('salesDate', addSlash(event.target.value));
                    },
                }), { placeholder: "MM/DD/YY" })),
                (inputError.salesDate === 'error' || errors.salesDate) && (React.createElement(Typography, { variant: "body-xs", color: "danger" },
                    ((_e = errors === null || errors === void 0 ? void 0 : errors.salesDate) === null || _e === void 0 ? void 0 : _e.type) === 'tryAgain' &&
                        inStoreErrors.salesDateNotFound,
                    (['required', 'minLength', 'invalid', 'pattern'].includes((_g = (_f = errors === null || errors === void 0 ? void 0 : errors.salesDate) === null || _f === void 0 ? void 0 : _f.type) !== null && _g !== void 0 ? _g : 'invalid') ||
                        inputError.salesDate === 'error') &&
                        inStoreErrors.salesDateInvalidFormat))),
            React.createElement(FormController, { className: "sui-mt-[8px] md:sui-mt-6", fullWidth: true, status: inputError.preTaxAmount || ((errors === null || errors === void 0 ? void 0 : errors.preTaxAmount) && 'error') },
                React.createElement(FormLabel, { htmlFor: "preTaxAmount" },
                    "Pre-Tax Amount",
                    React.createElement("sup", null, "*")),
                React.createElement(Input, __assign({ "aria-describedby": "preTaxAmount-input", fullWidth: true, id: "preTaxAmount" }, register('preTaxAmount', {
                    required: true,
                    minLength: 3,
                    onChange: function (event) {
                        return setValue('preTaxAmount', event.target.value);
                    },
                    onBlur: function (event) {
                        return setValue('preTaxAmount', event.target.value);
                    },
                }), { placeholder: "$" })),
                (inputError.preTaxAmount === 'error' || errors.preTaxAmount) && (React.createElement(Typography, { variant: "body-xs", color: "danger" }, inStoreErrors.preTaxAmountInvalidFormat))),
            errors.tryAgain404 && (React.createElement("div", { className: "sui-mt-6" },
                React.createElement(Typography, { color: "danger" }, inStoreErrors.api404Error))),
            errors.apiError && (React.createElement("div", { className: "sui-mt-6" },
                React.createElement(Typography, { color: "danger" }, (_h = errors === null || errors === void 0 ? void 0 : errors.apiError) === null || _h === void 0 ? void 0 : _h.message)))),
        React.createElement(AddReceiptDrawerFooter, { closeDrawer: closeDrawer, handleButtonClick: handleButtonClick, isLoading: isLoading, primaryButtonText: "Add In-Store Receipt", reset: reset, secondaryButtonText: "Cancel" })));
};
